export interface WorkLinkData {
  label: string;
  link: string;
}

export interface WorkItemData {
  org: string;
  role: string;
  text: string;
  date: string;
  contribution: string;
  links: WorkLinkData[];
}

export interface NewsItemData {
  author: string;
  text: string;
  date: string;
  link: string;
}

// Keep manually ordered from newest to oldest for easy editing.
export const workData: WorkItemData[] = [
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'GPT-5.2 to GPT-5.6',
    date: 'Jul 2026',
    contribution:
      'worked on frontend coding capabilities, visual artifact capabilities, reinforcement learning objective improvements, and alignment evaluations',
    links: [
      {
        label: 'GPT-5.6',
        link: 'https://openai.com/index/gpt-5-6/',
      },
      {
        label: 'GPT-5.5',
        link: 'https://openai.com/index/introducing-gpt-5-5/',
      },
      {
        label: 'GPT-5.4',
        link: 'https://openai.com/index/introducing-gpt-5-4/',
      },
      {
        label: 'GPT-5.2',
        link: 'https://openai.com/index/introducing-gpt-5-2/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'Introducing GPT-5',
    date: 'Aug 2025',
    contribution:
      'Led the unification of visual reasoning infrastructure across research and production',
    links: [
      {
        label: 'Announcement & Contributors',
        link: 'https://openai.com/index/introducing-gpt-5/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'Introducing ChatGPT agent: bridging research and action',
    date: 'Jul 2025',
    contribution: 'first long-horizon multimodal reasoning agent with context compaction',
    links: [
      {
        label: 'Announcement',
        link: 'https://openai.com/index/introducing-chatgpt-agent/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'OpenAI o3 and o4-mini System Card',
    date: 'Apr 2025',
    contribution: 'next generation reasoning models and coding improvements',
    links: [
      {
        label: 'System Card',
        link: 'https://openai.com/index/o3-o4-mini-system-card/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'Introducing GPT-4.1 in the API',
    date: 'Apr 2025',
    contribution: 'Instruction following and coding improvements with 1M-token context',
    links: [
      {
        label: 'Announcement',
        link: 'https://openai.com/index/gpt-4-1/',
      },
    ],
  },
  {
    org: 'UNICEF',
    role: 'Lead',
    text: 'OpenAI and UNICEF Accelerate Digital Textbook Access',
    date: 'Apr 2025',
    contribution:
      'Led the partnership with UNICEF to apply OpenAI models to make digital textbooks accessible to students in low-resource settings',
    links: [
      {
        label: 'Announcement',
        link: 'https://www.unicefusa.org/about-unicef-usa/partnerships/companies/openai',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Data',
    text: 'Introducing 4o Image Generation',
    date: 'Mar 2025',
    contribution: 'Data work for the imagegen model',
    links: [
      {
        label: 'Announcement',
        link: 'https://openai.com/index/introducing-4o-image-generation/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'Introducing GPT 4.5',
    date: 'Feb 2025',
    contribution:
      "Developed techniques to scalably supervise and align OpenAI's largest model at release",
    links: [
      {
        label: 'Announcement',
        link: 'https://openai.com/index/introducing-gpt-4-5/',
      },
    ],
  },
  {
    org: 'OpenAI',
    role: 'Post-Training',
    text: 'OpenAI o1',
    date: 'Sep 2024',
    contribution: 'the first model trained to reason before answering',
    links: [
      {
        label: 'Contributors',
        link: 'https://openai.com/openai-o1-contributions/',
      },
    ],
  },
];

export const newsData: NewsItemData[] = [
  {
    author: 'The Varsity',
    text: 'Opinion: Yes, the Aphrodite Project works',
    link: 'https://thevarsity.ca/2025/02/11/opinion-yes-the-aphrodite-project-works/',
    date: 'Feb 2025',
  },
  {
    author: 'The Straits Times',
    text: 'Falling out of love with dating apps? Young singles switch to events, other algorithms, old tricks',
    link: 'https://www.straitstimes.com/life/falling-out-of-love-with-dating-apps-young-singles-switch-to-events-other-algorithms-old-tricks',
    date: 'Jul 2024',
  },
  {
    author: 'University of Waterloo Imprint',
    text: 'Find love at UW, the UW way',
    link: 'https://archive.uwimprint.ca/article/find-love-at-uw-the-uw-way/',
    date: 'Feb 2024',
  },
  {
    author: 'The Tartan',
    text: 'Aphrodite Project relaunches annual match program at CMU',
    link: 'https://the-tartan.org/2024/02/12/aphrodite-project-relaunchesannual-match-program-at-cmu/',
    date: 'Feb 2024',
  },
  {
    author: 'The Straits Times',
    text: 'Platform for petitions to Govt taken down as it was just for internal testing: GovTech',
    link: 'https://www.straitstimes.com/singapore/platform-for-petitions-to-govt-taken-down-as-it-was-just-for-internal-testing-govtech',
    date: 'May 2022',
  },
  {
    author: 'The Straits Times',
    text: "S'pore exploring petition platform where 10,000 signatures guarantee ministry response",
    link: 'https://www.straitstimes.com/singapore/politics/spore-exploring-petition-platform-where-10000-signatures-guarantee-ministry-response',
    date: 'May 2022',
  },
  {
    author: 'The Harvard Crimson',
    text: 'Love at First Match',
    link: 'https://www.thecrimson.com/article/2021/2/11/project-aphrodite-2021/',
    date: 'Feb 2021',
  },
  {
    author: 'The Varsity',
    text: 'How a matchmaking algorithm paired up thousands of hopeless U of T romantics',
    link: 'https://thevarsity.ca/2020/07/06/how-a-matchmaking-algorithm-paired-up-thousands-of-hopeless-u-of-t-romantics/',
    date: 'Jul 2020',
  },
  {
    author: 'Mothership',
    text: 'Dating project for NUS & Yale-NUS students uses Nobel Prize-winning algorithm to find 1 ideal match',
    link: 'https://mothership.sg/2019/10/dating-project-nus-yale-nus-students/',
    date: 'Oct 2019',
  },
];
